import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem } from '@app/s1';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ser-in-gestione-select',
  templateUrl: './in-gestione-select.component.html',
  styleUrl: './in-gestione-select.component.scss'
})
export class InGestioneSelectComponent {

  @Input() control: UntypedFormControl;
  @Input() readonly: boolean;
  @Input() label: string = 'stazioni.fields.inGestione';

  items: IS1InputSelectItem[] = [];

  constructor(private translateService: TranslateService) {

    this.loadItems();

    this.translateService.onLangChange.subscribe(changed => {
      this.loadItems();
    })

  }

  private loadItems() {
    this.items = [
      { code: null, label: this.translateService.instant("stazioni.fields.inGestioneAll") },
      { code: true, label: this.translateService.instant("stazioni.fields.inGestioneYes") },
      { code: false, label: this.translateService.instant("stazioni.fields.inGestioneNo") },
    ];
  }

  ngOnInit(): void { }

}
